import { useMemo } from 'react';
import useCustomAnalytics from './use-custom-analytics';
import { useCatalog } from '~/hooks/use-catalog';
import { serializeProductOrKit } from '~/utils/serialize';
import useSiteMetadataQuery from '~/hooks/graphql/queries/use-site-metadata';

/* 
Put this hook on top level of product component,
product slug will pull all information available about product from the selectors.
*/
const useVariantAnalytics = (productSlug) => {
  const { track } = useCustomAnalytics();
  const { findProductBySlug } = useCatalog();
  const foundProduct = useMemo(() => findProductBySlug(productSlug), [productSlug]);

  const { site } = useSiteMetadataQuery() ?? {};

  const trackVariantClicked = ({ variant, locationDetail, collection }, data = {}) => {
    const url = `${site?.siteMetadata?.siteUrl}/${collection}/${productSlug}/`;
    const serializedProduct = serializeProductOrKit(foundProduct, variant.sku, { locationDetail, url: url, ...data });
    // Not using the SDK trackVariantClick method here because it fails to read the serialized product and pass the correct URL
    track('Variant Clicked', { ...serializedProduct });
  };

  return { trackVariantClicked };
};

export default useVariantAnalytics;
